import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const WARRANTIES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('WARRANTIES');
export const WARRANTIES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	WARRANTIES_CRUD_ACTION_CONSTANTS
);
